// extracted by mini-css-extract-plugin
export default {"box":"Cart_box__LuLfM"};